import type { AxiosInstance } from 'axios'

export const updateToken = (instance: AxiosInstance, token: string) => {
  instance.defaults.headers['Authorization'] = 'Bearer ' + token
  return instance
}
